export const validPhoneRegex = /\([1-9]\d\d\) \d\d\d-\d\d\d\d/;

export const urlHideNavBarRegex = new RegExp(/\/premium-plus-\d+\/?/g);

export const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const isEmailRegex = new RegExp(emailRegex);

/*
^: Asserts the start of the string.
[\w-.]+: Matches one or more word characters (\w), hyphens (-), or dots (.). This matches the local part of the email address.
@: Matches the "@" symbol.
([\w-]+\.)+: Matches one or more word characters or hyphens, followed by a dot. This is for the domain name.
[\w-]{2,4}: Matches between 2 to 4 word characters or hyphens. This is a basic approximation for the top-level domain (like .com, .org, etc.).
$: Asserts the end of the string.
*/
